import { render, staticRenderFns } from "./AlterarPrazoVencimentoFiltros.vue?vue&type=template&id=4717a6b6&scoped=true"
import script from "./AlterarPrazoVencimentoFiltros.vue?vue&type=script&lang=js"
export * from "./AlterarPrazoVencimentoFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4717a6b6",
  null
  
)

export default component.exports